var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStyledRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5671 6.36918C11.7157 6.2418 11.79 6.17811 11.8173 6.10232C11.8411 6.0358 11.8411 5.96303 11.8173 5.89651C11.79 5.82072 11.7157 5.75703 11.5671 5.62965L6.41042 1.20962C6.15459 0.990347 6.02668 0.88071 5.91839 0.878023C5.82427 0.875689 5.73437 0.917037 5.6749 0.990015C5.60646 1.07399 5.60646 1.24245 5.60646 1.57939V4.1942C4.30694 4.42154 3.11757 5.08003 2.23372 6.06873C1.27011 7.14664 0.73708 8.54159 0.736328 9.98742V10.36C1.37513 9.59045 2.17272 8.96807 3.07445 8.53549C3.86946 8.1541 4.72887 7.92818 5.60646 7.86865V10.4194C5.60646 10.7564 5.60646 10.9248 5.6749 11.0088C5.73437 11.0818 5.82427 11.1231 5.91839 11.1208C6.02668 11.1181 6.15459 11.0085 6.41042 10.7892L11.5671 6.36918Z",
    stroke: "#252A31",
    strokeWidth: 1.3382,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyledRightArrow);
export default __webpack_public_path__ + "static/media/styled-right-arrow.84d8e786eee14ea5478899d30e5b954d.svg";
export { ForwardRef as ReactComponent };